export const FUTURE_ROLES = [
  {
    id: 'frontend-developer',
    name: 'Frontend Developer',
    summary: 'Design and build modern web interfaces with responsive UI and accessible UX.',
    timeline: '4-6 months',
    salaryRange: '$60k - $120k',
    tags: ['HTML', 'CSS', 'JavaScript', 'React'],
    phases: [
      {
        title: 'Foundation',
        items: ['Web basics and HTTP', 'HTML and semantic markup', 'CSS layouts and responsive design']
      },
      {
        title: 'Framework',
        items: ['React fundamentals', 'State management patterns', 'Routing and data fetching']
      },
      {
        title: 'Professional',
        items: ['Testing and quality', 'Performance optimization', 'Portfolio projects']
      }
    ]
  },
  {
    id: 'backend-developer',
    name: 'Backend Developer',
    summary: 'Build secure APIs, data models, and scalable services for web and mobile apps.',
    timeline: '5-7 months',
    salaryRange: '$65k - $130k',
    tags: ['Node.js', 'APIs', 'Databases', 'Security'],
    phases: [
      {
        title: 'Foundation',
        items: ['Programming fundamentals', 'HTTP and REST principles', 'Database basics']
      },
      {
        title: 'Backend Core',
        items: ['Server frameworks', 'Authentication flows', 'Data modeling']
      },
      {
        title: 'Professional',
        items: ['Testing and monitoring', 'Deployment basics', 'Portfolio services']
      }
    ]
  },
  {
    id: 'fullstack-developer',
    name: 'Full-Stack Developer',
    summary: 'Own the full product stack from UI to backend services and deployment.',
    timeline: '6-9 months',
    salaryRange: '$70k - $140k',
    tags: ['Frontend', 'Backend', 'APIs', 'Deployment'],
    phases: [
      {
        title: 'Frontend',
        items: ['HTML, CSS, JavaScript', 'React or Vue basics', 'UX fundamentals']
      },
      {
        title: 'Backend',
        items: ['APIs and databases', 'Authentication', 'Server architecture']
      },
      {
        title: 'Launch',
        items: ['CI and hosting', 'Monitoring basics', 'Capstone projects']
      }
    ]
  },
  {
    id: 'react-native-developer',
    name: 'React Native Developer',
    summary: 'Build mobile apps for iOS and Android with a shared React codebase.',
    timeline: '4-6 months',
    salaryRange: '$65k - $125k',
    tags: ['React', 'Mobile UI', 'APIs', 'App Store'],
    phases: [
      {
        title: 'Foundation',
        items: ['JavaScript mastery', 'React fundamentals', 'Mobile UI basics']
      },
      {
        title: 'Mobile Core',
        items: ['Navigation patterns', 'Native device features', 'Data integration']
      },
      {
        title: 'Professional',
        items: ['Testing on devices', 'Release pipelines', 'Portfolio apps']
      }
    ]
  },
  {
    id: 'devops-engineer',
    name: 'DevOps Engineer',
    summary: 'Automate delivery, scale infrastructure, and keep systems reliable.',
    timeline: '5-8 months',
    salaryRange: '$75k - $145k',
    tags: ['Linux', 'CI/CD', 'Cloud', 'Monitoring'],
    phases: [
      {
        title: 'Foundation',
        items: ['Linux and networking', 'Git workflows', 'Scripting basics']
      },
      {
        title: 'Automation',
        items: ['CI/CD pipelines', 'Infrastructure as code', 'Containerization']
      },
      {
        title: 'Operations',
        items: ['Monitoring and alerts', 'Incident response', 'Scaling systems']
      }
    ]
  },
  {
    id: 'data-scientist',
    name: 'Data Scientist',
    summary: 'Turn data into insights using statistics, ML models, and storytelling.',
    timeline: '6-10 months',
    salaryRange: '$80k - $150k',
    tags: ['Python', 'Statistics', 'ML', 'Visualization'],
    phases: [
      {
        title: 'Foundation',
        items: ['Python for data', 'Statistics and probability', 'SQL essentials']
      },
      {
        title: 'Modeling',
        items: ['Machine learning basics', 'Model evaluation', 'Feature engineering']
      },
      {
        title: 'Portfolio',
        items: ['End-to-end projects', 'Data storytelling', 'Deployment basics']
      }
    ]
  },
  {
    id: 'ui-ux-designer',
    name: 'UI/UX Designer',
    summary: 'Create user-centered experiences with research, design, and prototyping.',
    timeline: '4-6 months',
    salaryRange: '$55k - $110k',
    tags: ['Research', 'Wireframes', 'Figma', 'Prototypes'],
    phases: [
      {
        title: 'Research',
        items: ['User interviews', 'Personas and journeys', 'Problem framing']
      },
      {
        title: 'Design',
        items: ['Visual systems', 'Component libraries', 'Interaction patterns']
      },
      {
        title: 'Portfolio',
        items: ['Case studies', 'Design critique', 'Presentation skills']
      }
    ]
  },
  {
    id: 'cybersecurity-analyst',
    name: 'Cybersecurity Analyst',
    summary: 'Protect systems with threat detection, audits, and security best practices.',
    timeline: '5-8 months',
    salaryRange: '$65k - $125k',
    tags: ['Security', 'Networking', 'Threats', 'Compliance'],
    phases: [
      {
        title: 'Foundation',
        items: ['Security principles', 'Network fundamentals', 'Linux basics']
      },
      {
        title: 'Defense',
        items: ['Threat detection', 'Security tools', 'Incident response']
      },
      {
        title: 'Professional',
        items: ['Security certifications', 'Audit practice', 'Security projects']
      }
    ]
  }
];
